<template>
  <div class="shipping-datetime pt20">
    <div class="row" v-if="isActive || isFilled">
      <div class="col-xs-2 col-sm-2 col-md-1">
        <div
          class="number-circle lh35 cl-white brdr-circle align-center weight-700"
          :class="{ 'bg-cl-th-accent' : isActive || isFilled, 'bg-cl-tertiary' : !isFilled && !isActive }"
        >
          5
        </div>
      </div>
      <div class="col-xs-8 col-sm-8 col-md-10">
        <div class="row ">
          <div class="col-xs-12" :class="{ 'cl-bg-tertiary' : !isFilled && !isActive }">
            <h3 class="m0">
              {{ $t('Delivery time') }}
            </h3>
          </div>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-1 end-xs">
        <i data-v-0c2f6ec6="" class="material-icons arrow-i"
           :class="{ 'active' : isActive }"
        >keyboard_arrow_right</i>
      </div>
    </div>
    <div class="row mt15" v-if="isActive">
      <div class="col-xs-12">
        <div class="row checkmark-customs mb10">
          <div v-if="isAsapDeliveryAllowed && currentPartner.shipping.asap" class="col-xs-6 flex start-xs relative">
            <label class=" py10 h4 pointer w-100 flex middle-xs center-xs"
                   :class="{
                     'is-checked' : deliveryTimeOption === 'asap' && enableAsapButton,
                     'is-disabled' : isAsapDeliveryDisabled || !enableAsapButton
                   }"
            >
              <i class="material-icons orange">whatshot</i>

              <div class="delivery">
                <span>{{ $t('ASAP') }}</span><br>
                <span v-if="!isPartnerOpened">{{ partnerWorkingTimeRange }}</span>
                <span v-else>{{ $t('up to 70 minutes') }}</span>
              </div>
              <input v-model="deliveryTimeOption" value="asap" :name="`delivery-time-option-${currentPartner.code}`"
                     type="radio" :disabled="isAsapDeliveryDisabled || !enableAsapButton || !isPartnerOpened"
              >
            </label>
          </div>
          <div class="col-xs-6 flex start-xs relative">
            <label class="py10 h4 pointer w-100 flex middle-xs center-xs"
                   :class="{'is-checked' : !isPartnerOpened || deliveryTimeOption === 'time'}"
            >
              <i data-v-0c2f6ec6="" class="material-icons">alarm_add</i>
              {{ $t('Choose delivery time') }}
              <input
                type="radio"
                value="time"
                name="delivery-time-option"
                v-model="deliveryTimeOption"
              >
            </label>
          </div>
        </div>
        <span class="validation-error" v-if="!deliveryTimeOption">{{ $t('Field is required') }}</span>
        <div v-if="deliveryTimeOption === 'asap' && isPartnerOpened" class="row fs16 mb35 slider-container">
          <div class="date col-xs-12">
            <p>
              За умови доступності кур‘єра поблизу, доставка буде виконана у найкоротший термін.
            </p>
          </div>
        </div>
        <div v-if="deliveryTimeOption === 'time'" class="row fs16 mb35 slider-container">
          <div class="date col-xs-12">
            <ul class="date-picker-wrap nav-tabs mb15">
              <li class="date-picker-elem nav-item relative pb10" v-for="(date, index) in dateTimeRanges" :key="index"
                  :class="{ 'active': toActive(index) }"
              >
                <a class="no-underline" @click.prevent="setActive(index)">
                  <span class="day bold">{{ getMoment(index) }}</span><br>
                  <span class="month h5">{{ getMonth(index) }}</span>
                </a>
                <span v-if="toActive(index)" class="corner" />
              </li>
            </ul>
          </div>
          <div class="tab-content col-xs-12">
            <div :id="index"
                 class="date-item tab-pane"
                 :class="{ 'active show': toActive(index) }"
                 v-for="(date, index) in dateTimeRanges"
                 :key="index"
            >
              <div class="time-range">
                <div class="time-range-item" v-for="(range) in date" :key="index + ' ' + range.value"
                     v-if="(range.status === 'open' || range.status === 'closing')"
                     :class="{ 'disabled-closed': range.status === 'closed' }"
                >
                  <label :class="{'radioStyled': true, 'is-checked': show == index + ' ' + range.value}"> {{ range.value }}
                    <input type="radio"
                           :disabled="range.status === 'closed'"
                           :value="index + ' ' + range.value"
                           name="time-ranges"
                           v-model="selectedDateTime"
                           @click="setDeliveryTime(index, range.value)"
                    >
                    <span class="checkmark" />
                    <span class="checkmark-right" v-if="range.status === 'closed'">
                      {{ $t('Not available') }}
                    </span>
                    <span class="checkmark-right checkmark-green" v-else>
                      {{ $t('Available') }}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="isActive">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-md-8 my15" style="margin: auto">
            <button-full
              data-testid="deliveryTimeSubmit"
              @click.native="sendDataToCheckout"
              :disabled="isDisable"
            >
              {{ $t('Continue to payment') }}
            </button-full>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!isActive && isFilled">
      <div class="col-xs-12">
        <div class="row fs16 brdr-bottom-1 brdr-cl-bg-secondary">
          <div class="col-xs-12">
            <div class="lh30 flex end-xs" v-if="isFilled && !isActive">
              <a href="#" class="cl-tertiary flex" @click.prevent="edit">
                <span class="pr5 h6">
                  {{ $t('Edit') }}
                </span>
                <i class="material-icons cl-tertiary">edit</i>
              </a>
            </div>
          </div>
          <div class="col-xs-12 h4 mb15 bg-cl-secondary" data-testid="deliveryTimeSummary">
            <div class="p-styled-block">
              <span class="pr15 h4">{{ deliveryTimeOption === 'time' ? selectedDateTime : $t('ASAP') }}</span>
              <tooltip v-if="deliveryTimeOption === 'asap'">
                {{ $t('За умови доступності кур‘єра поблизу, доставка буде виконана у найкоротший термін.') }}
              </tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storedCartToken } from '@vue-storefront/core/modules/cart/helpers/cartTokenCookie'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters, mapState } from 'vuex'
import { timezoneTime, partnerWorkingTime } from '@vue-storefront/core/helpers'
import BaseInput from 'theme/components/core/blocks/Form/BaseInput'
import BaseSelect from 'theme/components/core/blocks/Form/BaseSelect'
import ButtonFull from 'theme/components/theme/ButtonFull'
import Tooltip from 'theme/components/core/Tooltip'
import moment from 'moment'

const today = timezoneTime();
today.setHours(0, 0, 0, 0);

export default {
  name: 'DeliveryTime',
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    BaseInput,
    BaseSelect,
    ButtonFull,
    Tooltip
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.user.current
    }),
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),
    isDisable () {
      return this.deliveryTimeOption !== 'asap' && this.deliveryTime.datetime === ''
    },
    isPartnerOpened () { // check on partner working hours from vuestorefront-api method setPartnerOpenStatus()
      return (this.currentPartner.open);
    },
    isAsapDeliveryDisabled () { // check on disable asap from partner settings
      return (!this.isPartnerOpened || !this.isAsapDeliveryAllowed)
    },
    isAsapDeliveryAllowed () { // check on disable asap from location configuration and inform banners settings
      return this.getAsapDeliveryFromActiveLocation() && this.getAsapDeliveryFromActiveBanners()
    },
    getActiveRange () {
      return this.dateTimeRanges[this.activeItem].find(range => range.status !== 'closed').value
    },
    partnerWorkingTimeRange () {
      let workingTime = partnerWorkingTime(this.currentPartner)

      return `${workingTime.workFrom.substring(0, 5)} - ${workingTime.workTo.substring(0, 5)}`
    }
  },
  methods: {
    ...mapActions({
      getDeliveryTime: 'checkout/getDeliveryTime'
    }),
    toActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    getMoment: function (index) {
      moment.locale('uk');
      return moment(index).format('D');
    },
    getMonth: function (index) {
      moment.locale('uk');
      return moment(index).format('MMMM');
    },
    setDeliveryTime (index, value) {
      this.deliveryTime.datetime = value
      this.show = index + ' ' + value
    },
    sendDataToCheckout () {
      if (!this.isDisable) {
        this.$bus.$emit(
          'pickup-checkout-after-deliveryTimeDetails',
          this.selectedDateTime,
          this.$v,
          this.deliveryTimeOption === 'asap'
        )
        this.isFilled = true
      }
    },
    getResponsive () {
      return {
        350: {
          'items': 1,
          'edge-padding': 20
        },
        500: {
          'items': 2
        }
      }
    },
    edit () {
      if (this.isFilled) {
        this.$bus.$emit('pickup-checkout-before-edit', 'deliveryTime')
      }
    },
    getAsapDeliveryFromActiveLocation () {
      return this.currentLocation.hasOwnProperty('asap_delivery') && this.currentLocation.asap_delivery
    },
    getAsapDeliveryFromActiveBanners () {
      let isAsapDeliveryAllow = true
      if (this.currentLocation && this.currentLocation.hasOwnProperty('notification_banners')) {
        this.currentLocation.notification_banners.forEach((item) => {
          if (!item.asap_delivery) {
            isAsapDeliveryAllow = false
          }
        })
      }
      return isAsapDeliveryAllow
    },
    getActiveDay (days) {
      let availableDays = Object.entries(days).find(day => {
        return Array.isArray(day[1]) && day[1].filter(range => range.status !== 'closed').length > 0
      })
      return availableDays ? availableDays[0] : null
    }
  },
  data () {
    return {
      activeItem: false,
      displayTimeRanges: false,
      dateTimeRanges: null,
      selectedDate: false,
      selectedDateTime: '',
      show: false,
      isFilled: false,
      deliveryTime: {
        datetime: ''
      },
      deliveryTimeOption: 'asap',
      enableAsapButton: true,
      cartId: ''
    }
  },
  mounted () {
    this.deliveryTime.datetime = '';
    this.$nextTick(() => {
      this.cartId = storedCartToken()
      // K2-3036: use the fixed 'anywhere' code (this component is only ever used by
      // Anywhere.vue) - this used to pass this.$route.name (a route name, not a partner code).
      this.getDeliveryTime({
        partner_code: 'anywhere',
        location_code: this.currentLocation.code,
        shipping_method: 'delivery',
        cartId: this.cartId
      })
        .then((response) => {
          let availableDays = Object.entries(response)[0]
          if (this.currentLocation.code === 'lutsk') {
            this.dateTimeRanges = {}
            this.dateTimeRanges[availableDays[0].toString()] = {}
            this.dateTimeRanges[availableDays[0].toString()] = availableDays[1]
          } else {
            this.dateTimeRanges = response
            if (!this.dateTimeRanges[availableDays[0].toString()].length) {
              delete this.dateTimeRanges[availableDays[0].toString()]
            }
          }
          this.activeItem = this.getActiveDay(this.dateTimeRanges)
          if (this.activeItem) {
            this.setDeliveryTime(this.activeItem, this.getActiveRange)
            this.selectedDateTime = this.activeItem + ' ' + this.getActiveRange
          } else {
            this.$store.dispatch('notification/spawnNotification', {
              type: 'error',
              message: this.$t('No delivery time slots are available right now. Please try again later.'),
              action1: { label: this.$t('OK') }
            })
          }
        })
        .catch(error => {
          console.error(error)
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t('Failed to load delivery times. Please refresh the page and try again.'),
            action1: { label: this.$t('OK') },
            hasNoTimeout: true
          })
        });
      // check on asap delivery

      if (!this.currentPartner.shipping.asap || !this.isPartnerOpened || !this.isAsapDeliveryAllowed) {
        this.enableAsapButton = false
        this.deliveryTimeOption = 'time';
      }
    })
  },
  validations: {
    deliveryTime: {
      datetime: {
        required
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .p-styled-block {
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .date-picker-elem.active a {
    color: rgb(255, 255, 255);
  }

  .date-picker-elem.active a {
    color: rgb(255, 255, 255);
    background: #11bb2e;
    border: 1px solid #11bb2e;
  }

  .date-picker-elem a.underline:after, .date-picker-elem a:not(.no-underline):hover:after {
    height: 0;
  }
  .day{
    font-size: 21px;
  }
  .corner{
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 0 10px;
    border-color: #11bb2e transparent transparent transparent;
  }

  .date-picker-elem a {
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: none;
    color: #11bb2e;
    cursor: pointer;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: 1px solid #ebebeb;
  }

  .date-picker-elem {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 8px;

  }

  .date-picker-wrap {
    display: flex;
    overflow: auto;
    padding-left: 0;
  }

  .tab-content > .tab-pane.active {
    display: block;
  }

  .tab-content > .tab-pane {
    display: none;
  }

  .time-range-item .radioStyled {
    margin-bottom: 0;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-left: -12px;
    padding-left: 40px;
    display: block;
    position: relative;
    text-align: left;
  }

  .time-range .time-range-item .radioStyled.is-checked {
    border: 1px solid #11bb2e;
    border-radius: 6px;

  }

  .time-range .time-range-item .radioStyled .checkmark {
    left: 12px !important;
    top: 12px !important;
    border: 1px solid green;
    position: absolute;
    height: 20px;
    width: 20px;
    border-radius: 50%;
  }

  .tab-content .radioStyled input:checked ~ .checkmark:after {
    display: block;
  }

  .tab-content .radioStyled .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #828282;
  }

  .tab-content .radioStyled input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .time-range .time-range-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin-bottom: 12px;
    padding-left: 12px;

  }

  .disabled-closed {
    background: #cacaca;
    color: #000;
  }

  .disabled-delivery {
    color: grey;
    font-weight: 700;
    display: none;
  }

  .shipping-datetime .checkmark-customs .disabled-delivery label {
    border: 1px solid #d0d0d0;
    color: #d0d0d0;
  }

  .shipping-datetime .checkmark-customs .disabled-delivery .cl-black span {
    color: #d0d0d0;
  }

  .shipping-datetime {
    .checkmark-customs {
      .is-checked{
        border: 1px solid #11bb2e;
        border-radius: 10px;
        background-color: #11bb2e;
        color: #fff;
        opacity: 1;
      }
      label {
        border: 1px solid #11bb2e;
        border-radius: 10px;
        color: #11bb2e;
        font-size: 13px;
        opacity: 0.5;
        .delivery{
          font-size: 13px;
        }
        i {
          margin-right: 5px;
        }
        &.is-checked {
          i {
            color: #fff;
            &.orange{
              color: #f8e71c;
            }
          }
        }
        &.is-disabled {
          border: 1px solid #f1f1f1;
          background-color: #f1f1f1;
          color: #999999;
          i {
            color: #aaa;
          }
        }
        @media (min-width: 769px) {
          font-size: 16px;
        }
      }
      input {
        opacity: 0;
        height: 0;
        position: absolute;
      }
    }
  }

  .orange{
    color: #f8e71c;
  }

  .checkmark-right.checkmark-green{
    color: #11bb2e;
  }
  .checkmark-right{
    right: 12px!important;
    top: 12px!important;
    left: auto!important;
    position: absolute;
    color: #000;
  }
</style>
